/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type FieldSettingsType from '@jira/spa-apps__project-settings-fields/src/ExportedDefault.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { Route, Match, Query } from '@atlassian/react-resource-router';

export const LazyFieldsSettings: LazyComponent<{
	(props: { route: Route; match: Match; query: Query }): React.JSX.Element;
	displayName: string;
}> = lazyForPaint<typeof FieldSettingsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-fields", jiraSpaEntry: "async-project-settings-fields" */ '@jira/spa-apps__project-settings-fields/src/ExportedDefault.tsx'
		),
	),
);

const AsyncFieldsSettings = (): React.JSX.Element => (
	<LazyPage Page={LazyFieldsSettings} pageId="project-settings-fields" shouldShowSpinner />
);

export default AsyncFieldsSettings;
